/* Meraqi Homecare — interactions globales (menu mobile + accordéons).
   Le méga-menu desktop est géré en CSS pur (group-hover / focus-within). */
(function () {
  "use strict";

  var header = document.querySelector("[data-header]");
  if (!header) return;

  var toggle = header.querySelector("[data-menu-toggle]");

  function setMenu(open) {
    header.classList.toggle("is-menu-open", open);
    if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
    document.documentElement.classList.toggle("overflow-hidden", open);
  }

  if (toggle) {
    toggle.addEventListener("click", function () {
      setMenu(!header.classList.contains("is-menu-open"));
    });
  }

  // Fermer le menu mobile au clic sur un lien
  header.querySelectorAll("[data-mobile-drawer] a").forEach(function (a) {
    a.addEventListener("click", function () {
      setMenu(false);
    });
  });

  // Échap ferme le menu mobile
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") setMenu(false);
  });
})();

/* Meraqi Homecare — accordéons (menu mobile + fiche produit + FAQ).
   Pilotés par la classe is-open et le CSS data-state de theme.css. */
(function () {
  "use strict";
  document.querySelectorAll("[data-accordion-toggle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var item = btn.closest("[data-accordion]");
      if (!item) return;
      var open = item.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
  });
})();

/* Meraqi Homecare — galerie produit.
   Clic sur une miniature = image principale. Au changement de parfum, n'affiche que
   les photos de ce parfum (ou de ce duo), puis sa pyramide, puis les photos génériques.
   Duo sans photo dédiée : les deux flacons recto côte à côte. */
(function () {
  "use strict";

  document.querySelectorAll("[data-gallery]").forEach(function (gal) {
    var section = gal.closest("section");
    var main = gal.querySelector("[data-gallery-main]");
    var duo = gal.querySelector("[data-gallery-duo]");
    var duoThumb = gal.querySelector("[data-gallery-duo-thumb]");
    var strip = gal.querySelector("[data-gallery-strip]");
    var order = (gal.getAttribute("data-order") || "").split(",");
    var multi = gal.getAttribute("data-multi") === "1";
    var fallbackSrc = main ? main.getAttribute("src") : null;
    var prevBtn = gal.querySelector("[data-gallery-prev]");
    var nextBtn = gal.querySelector("[data-gallery-next]");
    var rectos = {};
    var rectosEl = gal.querySelector("[data-gallery-rectos]");
    if (rectosEl) {
      try { rectos = JSON.parse(rectosEl.textContent) || {}; } catch (e) { rectos = {}; }
    }

    function thumbs() {
      return strip ? [].slice.call(strip.querySelectorAll("[data-gallery-thumb]")) : [];
    }

    function setDuo(visible) {
      if (!duo) return;
      duo.classList.toggle("hidden", !visible);
      duo.classList.toggle("grid", visible);
      if (main) main.classList.toggle("invisible", visible);
    }

    function visibleThumbs() {
      return thumbs().filter(function (t) { return !t.classList.contains("hidden"); });
    }

    // Flèches ‹ › : défilent parmi les miniatures visibles (donc celles du parfum choisi), en boucle
    function updateArrows() {
      var many = visibleThumbs().length > 1;
      [prevBtn, nextBtn].forEach(function (b) {
        if (!b) return;
        b.classList.toggle("hidden", !many);
        b.classList.toggle("flex", many);
      });
    }

    function step(dir) {
      var list = visibleThumbs();
      if (list.length < 2) return;
      var current = list.filter(function (t) { return t.classList.contains("is-active"); })[0];
      var i = current ? list.indexOf(current) : 0;
      show(list[(i + dir + list.length) % list.length]);
    }

    if (prevBtn) prevBtn.addEventListener("click", function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { step(1); });

    // Fondu enchaîné : l'image sort (flou léger), la nouvelle entre une fois chargée.
    // Un jeton annule les changements dépassés quand on clique vite sur les flèches.
    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var swapToken = 0;
    function swapMain(src) {
      if (!main || main.getAttribute("src") === src) return;
      var token = ++swapToken;
      var reveal = function () { if (token === swapToken) main.classList.remove("is-swapping"); };
      main.classList.add("is-swapping");
      setTimeout(function () {
        if (token !== swapToken) return;
        main.removeAttribute("srcset");
        main.onload = reveal;
        main.onerror = reveal;
        main.src = src;
        if (main.complete) reveal();
        setTimeout(reveal, 1200); // filet de sécurité si l'événement load ne vient pas
      }, reduceMotion ? 0 : 130);
    }

    function show(thumb) {
      if (thumb && thumb.hasAttribute("data-gallery-duo-thumb")) {
        setDuo(true);
      } else {
        setDuo(false);
        var img = thumb ? thumb.getAttribute("data-img") : fallbackSrc;
        if (img) swapMain(img);
      }
      thumbs().forEach(function (t) { t.classList.toggle("is-active", t === thumb); });
    }

    function fillDuo(el, a, b, label) {
      var ia = el.querySelector("[data-duo-a]");
      var ib = el.querySelector("[data-duo-b]");
      if (ia) { ia.src = rectos[a]; ia.alt = label; }
      if (ib) { ib.src = rectos[b]; ib.alt = ""; }
    }

    function apply(slugs) {
      var uniq = slugs.filter(function (v, i) { return slugs.indexOf(v) === i; });
      var key = "|" + order.filter(function (s) { return uniq.indexOf(s) >= 0; }).join("|") + "|";
      var matched = 0;

      thumbs().forEach(function (t) {
        var visible;
        if (t.hasAttribute("data-gallery-duo-thumb")) return;
        if (t.hasAttribute("data-pyr")) {
          visible = uniq.indexOf(t.getAttribute("data-pyr")) >= 0;
        } else if (t.getAttribute("data-key") === "|") {
          visible = true;
        } else {
          visible = t.getAttribute("data-key") === key;
          if (visible) matched++;
        }
        t.classList.toggle("hidden", !visible);
      });

      // Pyramides dans l'ordre de sélection (1re fragrance puis 2e), avant les photos génériques
      if (strip) {
        var firstGeneric = strip.querySelector('[data-key="|"]');
        uniq.forEach(function (s) {
          var p = strip.querySelector('[data-pyr="' + s + '"]');
          if (p) strip.insertBefore(p, firstGeneric);
        });
      }

      var useDuo = multi && matched === 0 && slugs.length > 1 && rectos[slugs[0]] && rectos[slugs[1]];
      if (duoThumb) {
        duoThumb.classList.toggle("hidden", !useDuo);
        if (useDuo) {
          var label = "Deux flacons : " + slugs.join(" et ").replace(/-/g, " ");
          fillDuo(duoThumb, slugs[0], slugs[1], label);
          if (duo) fillDuo(duo, slugs[0], slugs[1], label);
        }
      }

      show(visibleThumbs()[0] || null);
      updateArrows();
    }

    thumbs().forEach(function (thumb) {
      thumb.addEventListener("click", function () { show(thumb); });
    });
    var firstThumb = visibleThumbs()[0];
    if (firstThumb) firstThumb.classList.add("is-active");
    updateArrows();

    if (section) {
      section.addEventListener("meraqi:fragrances", function (e) {
        if (e.detail && e.detail.slugs) apply(e.detail.slugs);
      });
    }
  });
})();

/* Meraqi Homecare — sélecteur de variantes (pastilles fragrance + pills format).
   Résout l'id de variante depuis les options choisies puis met à jour prix + bouton. */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  // Apparition douce d'un texte qui vient de changer (WAAPI, sans librairie)
  function softIn(el) {
    if (reduceMotion || !el.animate) return;
    el.animate(
      [{ opacity: 0, transform: "translateY(3px)" }, { opacity: 1, transform: "none" }],
      { duration: 240, easing: "cubic-bezier(0.23, 1, 0.32, 1)" }
    );
  }

  function initPicker(picker) {
    var dataEl = picker.querySelector("[data-variant-data]");
    var idInput = picker.querySelector("[data-variant-id]");
    if (!dataEl || !idInput) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    var form = picker.closest("form");
    var priceEl = form ? form.querySelector("[data-price]") : null;
    var onceEl = form ? form.querySelector("[data-price-once]") : null;
    var subEl = form ? form.querySelector("[data-price-sub]") : null;
    var addBtn = form ? form.querySelector("[data-add]") : null;
    var addLabel = addBtn ? addBtn.querySelector("[data-add-label]") : null;
    var sectionEl = picker.closest("section");
    var restockEl = sectionEl ? sectionEl.querySelector("[data-restock]") : null;

    function slug(v) {
      return (v || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");
    }

    // Regroupe les radios par option (opt-1, opt-2…), triées par position
    var groups = {};
    picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
      (groups[input.name] = groups[input.name] || []).push(input);
    });
    var names = Object.keys(groups).sort(function (a, b) {
      return parseInt(a.replace(/\D/g, ""), 10) - parseInt(b.replace(/\D/g, ""), 10);
    });
    if (!names.length) return;

    function checkedIn(name) {
      return groups[name].filter(function (i) { return i.checked; })[0];
    }

    // Conteneur d'affichage (libellé + note) propre à CETTE option fragrance
    function fragranceBlock(input) {
      var el = input.parentElement;
      while (el && el !== picker) {
        if (el.querySelector("[data-fragrance-name]")) return el;
        el = el.parentElement;
      }
      return null;
    }

    function selectedValues() {
      return names.map(function (n) {
        var c = checkedIn(n);
        return c ? c.value : null;
      });
    }

    function matches(variant, values) {
      if (!variant.options || variant.options.length !== values.length) return false;
      for (var i = 0; i < values.length; i++) {
        if (variant.options[i] !== values[i]) return false;
      }
      return true;
    }

    function update() {
      var values = selectedValues();
      var variant = variants.filter(function (v) { return matches(v, values); })[0];

      // Libellé + note : met à jour le bloc de CHAQUE option fragrance (pas seulement la 1re)
      names.forEach(function (n) {
        var chosen = checkedIn(n);
        if (!chosen) return;
        var note = chosen.getAttribute("data-note");
        if (note === null) return; // pas une option fragrance (ex. Format) → on ignore
        var block = fragranceBlock(chosen);
        if (!block) return;
        var nEl = block.querySelector("[data-fragrance-name]");
        var noEl = block.querySelector("[data-fragrance-note]");
        if (nEl && nEl.textContent !== chosen.value) { nEl.textContent = chosen.value; softIn(nEl); }
        if (noEl && noEl.textContent !== note) { noEl.textContent = note; softIn(noEl); }

        // Intensité (jauge + libellé) et badge « Le favori »
        var level = parseInt(chosen.getAttribute("data-intensity"), 10) || 0;
        var intEl = block.querySelector("[data-fragrance-intensity]");
        if (intEl) {
          intEl.classList.toggle("hidden", level === 0);
          var dots = intEl.querySelectorAll("[data-intensity-dots] > span");
          for (var d = 0; d < dots.length; d++) {
            dots[d].classList.toggle("bg-prune", d < level);
            dots[d].classList.toggle("bg-lin", d >= level);
          }
          var labEl = intEl.querySelector("[data-intensity-label]");
          if (labEl) labEl.textContent = chosen.getAttribute("data-intensity-label") || "";
          var srEl = intEl.querySelector("[data-intensity-sr]");
          if (srEl) srEl.textContent = "Intensité " + level + " sur 5";
          var favEl = intEl.querySelector("[data-fragrance-favorite]");
          if (favEl) favEl.classList.toggle("hidden", chosen.getAttribute("data-favorite") !== "1");
        }
      });

      // Galerie : annonce les parfums choisis (dans l'ordre des options) pour n'afficher que leurs photos
      if (sectionEl) {
        var fragrances = [];
        names.forEach(function (n) {
          var c = checkedIn(n);
          if (c && c.getAttribute("data-note") !== null) fragrances.push(slug(c.value));
        });
        if (fragrances.length) {
          sectionEl.dispatchEvent(new CustomEvent("meraqi:fragrances", { detail: { slugs: fragrances } }));
        }
      }

      // Valeurs indisponibles : une valeur est épuisée si, combinée aux autres choix, aucune variante dispo n'existe
      names.forEach(function (n, gi) {
        groups[n].forEach(function (input) {
          var test = values.slice();
          test[gi] = input.value;
          var ok = variants.some(function (v) {
            return v.available && matches(v, test);
          });
          var label = input.closest("label");
          if (label) label.classList.toggle("is-soldout", !ok);
        });
      });

      var available = variant ? variant.available : false;

      if (variant) {
        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price;
        if (onceEl) onceEl.textContent = variant.price;
        if (subEl && variant.price_sub) subEl.textContent = variant.price_sub;
      }

      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.classList.toggle("opacity-50", !available);
        addBtn.classList.toggle("hidden", !available);
      }

      // Epuise -> on propose l'alerte retour en stock a la place du bouton d'achat
      if (restockEl) {
        restockEl.classList.toggle("hidden", available);
        if (!available) {
          var label = values.filter(Boolean).join(" / ");
          var nameEl = restockEl.querySelector("[data-restock-variant]");
          if (nameEl && label) nameEl.textContent = label;
          var tagsEl = restockEl.querySelector("[data-restock-tags]");
          if (tagsEl) {
            tagsEl.value = label
              ? "retour-stock, retour-stock-" + slug(label)
              : "retour-stock";
          }
        }
      }
      if (addLabel) {
        addLabel.textContent = !variant
          ? "Indisponible"
          : available
          ? "Ajouter au panier · " + variant.price
          : "Épuisé";
      }
    }

    picker.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.addEventListener("change", update);
    });

    update();
  }

  document.querySelectorAll("[data-variant-picker]").forEach(initPicker);
})();

/* Meraqi Homecare — onglets (collection mise en avant « Nos favoris »). */
(function () {
  "use strict";

  document.querySelectorAll("[data-tabs]").forEach(function (tablist) {
    var section = tablist.closest("section");
    if (!section) return;
    var panelsWrap = section.querySelector("[data-tab-panels]");
    if (!panelsWrap) return;
    var tabs = tablist.querySelectorAll("[data-tab]");
    var panels = panelsWrap.querySelectorAll("[data-tab-panel]");

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var idx = tab.getAttribute("data-tab");
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle("is-active", active);
          t.setAttribute("aria-selected", active ? "true" : "false");
        });
        panels.forEach(function (p) {
          p.classList.toggle("hidden", p.getAttribute("data-tab-panel") !== idx);
        });
      });
    });
  });
})();

/* Meraqi Homecare — animations de navigation.
   1) En-tête : ombre douce dès qu'on a défilé.
   2) Apparition au défilement, une seule fois : titres de section, cartes des grilles (en cascade),
      grandes images éditoriales (dévoilées de bas en haut). Ce qui est déjà à l'écran au chargement
      n'est pas animé, pour ne pas retarder l'affichage. Sans JavaScript, tout reste visible. */
(function () {
  "use strict";

  var header = document.querySelector("[data-header]");
  if (header) {
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle("is-scrolled", window.scrollY > 8);
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var main = document.querySelector("main");
  if (reduceMotion || !main || !("IntersectionObserver" in window)) return;

  // Grilles dont les cartes apparaissent en cascade (accueil, collection, journal, recherche…)
  var GRIDS = "[data-tab-panel], .grid.lg\\:grid-cols-4, .grid.lg\\:grid-cols-3, .grid.md\\:grid-cols-3";
  var STAGGER = 70; // ms entre deux cartes
  var targets = [];

  function mark(el, kind, delay) {
    if (!el || el.hasAttribute("data-reveal")) return;
    el.setAttribute("data-reveal", kind);
    if (delay) el.style.setProperty("--reveal-delay", delay + "ms");
    targets.push(el);
  }

  main.querySelectorAll(GRIDS).forEach(function (grid) {
    if (grid.closest("[data-gallery], form")) return;
    Array.prototype.forEach.call(grid.children, function (child, i) {
      mark(child, "up", Math.min(i, 5) * STAGGER);
    });
  });

  main.querySelectorAll("section h2").forEach(function (h2) {
    var block = h2.parentElement;
    if (!block || block.closest("[data-reveal], article, a")) return;
    mark(block, "up", 0);
  });

  var firstSection = main.querySelector("section");
  main.querySelectorAll(".relative.overflow-hidden").forEach(function (box) {
    if (!box.querySelector("img.object-cover")) return;
    if (box.closest("[data-gallery], [data-reveal], article, a")) return;
    if (firstSection && firstSection.contains(box)) return;
    mark(box, "image", 0);
  });

  if (!targets.length) return;

  // Une fois révélé, on retire le marquage : la carte retrouve ses propres transitions (survol).
  function settle(el) {
    el.removeAttribute("data-reveal");
    el.style.removeProperty("--reveal-delay");
  }
  function reveal(el) {
    el.classList.add("is-revealed");
    var delay = parseInt(el.style.getPropertyValue("--reveal-delay"), 10) || 0;
    setTimeout(function () { settle(el); }, delay + 1500);
  }

  // Déjà visible au chargement : affiché d'emblée, sans animation
  var vh = window.innerHeight;
  targets.forEach(function (el) {
    var r = el.getBoundingClientRect();
    if (r.bottom > 0 && r.top < vh * 0.92 && r.height > 0) {
      el.classList.add("is-revealed");
      settle(el);
    }
  });
  document.documentElement.classList.add("has-reveal");

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      io.unobserve(entry.target);
      reveal(entry.target);
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });

  targets.forEach(function (el) {
    if (el.hasAttribute("data-reveal")) io.observe(el);
  });
})();

/* Meraqi Homecare — barre d'annonce défilante.
   Duplique le groupe de messages pour couvrir l'écran, règle la durée selon la vitesse (px/s)
   et reprend la position d'une page à l'autre (sessionStorage) pour éviter un saut à chaque clic. */
(function () {
  "use strict";

  var bar = document.querySelector("[data-marquee]");
  if (!bar) return;
  var viewport = bar.querySelector("[data-marquee-viewport]");
  var track = bar.querySelector("[data-marquee-track]");
  var group = bar.querySelector("[data-marquee-group]");
  var toggle = bar.querySelector("[data-marquee-toggle]");
  if (!viewport || !track || !group || !group.children.length) return;

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduceMotion) {
    bar.classList.add("is-static");
    return;
  }

  var speed = parseFloat(bar.getAttribute("data-speed")) || 35;
  var KEY_START = "meraqi-marquee-start";
  var KEY_PAUSED = "meraqi-marquee-paused";
  function read(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
  function write(key, value) {
    try { if (value === null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, value); } catch (e) {}
  }

  var builtFor = "";
  function build() {
    var width = group.getBoundingClientRect().width;
    var key = Math.round(width) + "x" + viewport.clientWidth;
    if (!width || key === builtFor) return;
    builtFor = key;

    track.querySelectorAll("[data-marquee-clone]").forEach(function (c) { c.remove(); });
    // Assez de copies pour couvrir l'écran pendant toute une boucle
    var copies = Math.ceil((viewport.clientWidth + width) / width);
    for (var i = 0; i < copies; i++) {
      var clone = group.cloneNode(true);
      clone.removeAttribute("data-marquee-group");
      clone.setAttribute("data-marquee-clone", "");
      clone.setAttribute("aria-hidden", "true");
      clone.querySelectorAll("a, button").forEach(function (el) { el.setAttribute("tabindex", "-1"); });
      track.appendChild(clone);
    }

    var duration = width / speed;
    var start = parseInt(read(KEY_START), 10);
    if (!start) { start = Date.now(); write(KEY_START, String(start)); }
    var offset = ((Date.now() - start) / 1000) % duration;

    track.style.setProperty("--marquee-shift", width + "px");
    track.style.setProperty("--marquee-duration", duration.toFixed(2) + "s");
    track.style.setProperty("--marquee-delay", (-offset).toFixed(2) + "s");
    bar.classList.add("is-running");
  }

  function setPaused(paused) {
    bar.classList.toggle("is-paused", paused);
    if (toggle) {
      toggle.setAttribute("aria-pressed", paused ? "true" : "false");
      toggle.setAttribute("aria-label", paused ? "Reprendre le défilement" : "Mettre en pause le défilement");
    }
    write(KEY_PAUSED, paused ? "1" : null);
  }

  if (toggle) {
    toggle.classList.remove("hidden");
    toggle.classList.add("flex");
    toggle.addEventListener("click", function () { setPaused(!bar.classList.contains("is-paused")); });
  }
  setPaused(read(KEY_PAUSED) === "1");

  build();
  // La police web change la largeur du texte une fois chargée : on recalcule
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(build, 200);
  });
})();
